// Reservations translations for React Admin resource
export const reservationsResource = {
  name: '預約',
  fields: {
    id: '預約編號',
    status: '狀態',
    siteId: '站點',
    chargerId: '充電器',
    connectorId: '連接器',
    appUserId: '用戶',
    vehicleId: '車輛',
    requestedChargerTypeId: '充電器類型',
    reservationMode: '模式',
    accessMode: '存取',
    startTime: '開始時間',
    slotEndAt: '時段結束',
    holdUntil: '保留至',
    durationMinutes: '時長',
    policyId: '政策',
    feeAmount: '費用金額',
    feePolicy: '費用政策',
    walletHoldAmount: '錢包凍結',
    walletHoldStatus: '凍結狀態',
    transactionId: '關聯交易',
    modificationCount: '修改次數',
    modifiedAt: '最後修改',
    cancelledAt: '取消時間',
    cancelledBy: '取消者',
    cancelledReason: '取消原因',
    adminNotes: '管理員備註',
    assignedAt: '指派時間',
    reassignmentCount: '重指派次數',
    ocppReservationId: 'OCPP 預約編號',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
};

// Custom reservations translations for components
export const reservations = {
  subtitle: '管理充電預約',
  list: {
    title: '預約',
    subtitle: '管理充電預約',
    searchPlaceholder: '搜尋預約',
    noReservations: '找不到預約',
  },
  show: {
    subtitle: '預約詳情',
    sections: {
      summary: '摘要',
      policySnapshot: '政策快照',
      feeAndWallet: '費用與錢包',
      linkedSession: '關聯充電時段',
      modifications: '修改與稽核',
    },
    actions: {
      cancel: '取消預約',
      captureNoShow: '徵收失約費',
      refreshAssignment: '重新指派',
      forceReleaseHold: '強制釋放凍結',
      confirmCancel: '確定要取消此預約嗎？',
      confirmCapture: '確定要徵收失約費嗎？',
      confirmRefresh: '重新將此預約指派至新的充電器？',
      confirmForceRelease: '此操作會釋放錢包凍結，但不變更預約狀態。僅用於修復卡住的凍結。是否繼續？',
      reasonPlaceholder: '選填原因或備註',
    },
  },
  edit: {
    title: '編輯預約',
    subtitle: '更新預約資料',
    backToList: '返回預約列表',
    adminNotes: '管理員備註',
    cancellationReason: '取消原因',
    statusChangeWarning: '狀態變更受預約生命週期政策限制。',
  },
  statuses: {
    pending_payment: '待付款',
    confirmed: '已確認',
    active: '使用中',
    completed: '已完成',
    cancelled: '已取消',
    no_show: '失約',
    expired: '已過期',
  },
  modes: {
    fixed_slot: '固定時段',
    next_slot: '下一時段',
  },
  accessModes: {
    reservation_only: '僅限預約',
    reserve_or_fcfs: '預約或先到先用',
  },
  feePolicies: {
    none: '免費',
    hold_release: '凍結並釋放',
    hold_apply: '凍結並抵扣',
    hold_forfeit_on_noshow: '凍結（失約則沒收）',
  },
  feePolicyTooltips: {
    none: '不收取預約費用。',
    hold_release: '預約時自錢包凍結費用；無論充電完成或失約均會釋放。',
    hold_apply: '預約時自錢包凍結費用；作為充電費用之預付。',
    hold_forfeit_on_noshow: '預約時自錢包凍結費用；準時到場則釋放，失約則沒收。',
  },
  walletHoldStatus: {
    pending: '待處理',
    held: '已凍結',
    released: '已釋放',
    captured: '已徵收',
  },
  wallet: {
    timeline: '錢包紀錄',
    reasons: {
      hold: '凍結款項',
      release: '釋放凍結',
      apply: '抵扣充電費用',
      noshow_capture: '失約沒收',
    },
    types: {
      pre_auth: '預先授權',
      reservation_fee_applied: '預約費用抵扣',
      reservation_forfeit: '預約沒收',
    },
    statuses: {
      hold: '凍結',
      released: '已釋放',
      applied: '已抵扣',
      forfeited: '已沒收',
    },
    empty: '此預約沒有錢包紀錄',
  },
  filters: {
    search: '搜尋',
    allSites: '所有站點',
    allChargers: '所有充電器',
    allUsers: '所有用戶',
    allStatuses: '所有狀態',
    allPolicies: '所有政策',
    fromDate: '起日',
    toDate: '迄日',
    chargerNeedsSite: '請先選擇站點',
  },
  calendar: {
    title: '行事曆檢視',
    selectSite: '請先選擇站點',
    selectCharger: '所有充電器（選填）',
    allChargers: '所有充電器',
    dayView: '日檢視',
    weekView: '週檢視',
    today: '今天',
    legend: '圖例',
    legendConfirmed: '已確認',
    legendActive: '使用中',
    legendNoShow: '失約',
    legendCompleted: '已完成',
    legendCancelled: '已取消',
    noReservations: '此範圍內無預約',
    mobileHint: '行事曆檢視最適合在桌面瀏覽',
    openDetail: '開啟完整詳情',
  },
  policySnapshot: {
    title: '預約時政策',
    readOnlyNote: '此為預約建立時的政策快照。目前政策可能已有變動。',
    reservationMode: '預約模式',
    accessMode: '存取模式',
    holdMinutes: '保留時間（分鐘）',
    slotDurationMinutes: '時段長度（分鐘）',
    slotGranularityMinutes: '時段刻度（分鐘）',
    minLeadMinutes: '最短提前時間（分鐘）',
    maxLeadMinutes: '最長提前時間（分鐘）',
    maxActivePerUser: '每位用戶最大同時數',
    cancelWindowMinutes: '取消期限（分鐘）',
    modifyWindowMinutes: '修改期限（分鐘）',
    maxModifications: '最多修改次數',
    feePolicy: '費用政策',
    noShowPenaltyAmount: '失約罰款',
    allowedMembershipLevels: '允許會員等級',
    allowedUserGroupIds: '允許用戶群組',
    requireWalletBalance: '需有錢包餘額',
  },
  applicablePolicy: {
    title: '適用的預約政策',
    none: '此對象目前無適用的預約政策。',
    viewFull: '查看完整政策',
    priority: '優先順序',
    effectiveFrom: '生效起日',
    effectiveUntil: '生效終止',
  },
  fee: {
    title: '費用摘要',
    walletHoldChip: '錢包凍結',
    held: '預約時凍結',
    applied: '抵扣充電費用',
    forfeited: '失約沒收',
    refundReason: '退款原因',
  },
  linkedSession: {
    title: '關聯充電時段',
    transactionId: '交易編號',
    sessionCost: '充電費用',
    reservationApplied: '預約抵扣',
    net: '淨額',
    none: '尚無關聯時段',
  },
  modifications: {
    count: '修改次數',
    lastModified: '最後修改',
    cancelledAt: '取消時間',
    cancelledBy: '取消者',
    cancelledReason: '取消原因',
    auditLog: '稽核紀錄',
    auditEmpty: '此預約無稽核紀錄',
  },
  tooltips: {
    vendorScope: '您僅可查看所屬商戶下的預約。',
    noShowPenalty: '用戶未於保留時間內抵達時，自錢包扣除的金額。',
    walletHold: '預約費用會自用戶錢包凍結直至充電完成。',
    policySnapshotReadOnly: '此快照不可變更。目前政策可能已有變動。',
  },
  refundLabel: {
    none: '不收費',
    holdRelease: '全額退款',
    holdApply: '抵扣充電費用',
    holdForfeit: '準時到場可退款；失約則沒收',
  },
  notifications: {
    cancelled: '預約已取消',
    noShowCaptured: '失約費已徵收',
    reassigned: '預約已重新指派',
    holdReleased: '錢包凍結已強制釋放',
    updated: '預約已更新',
    error: {
      cancel: '取消預約失敗',
      capture: '徵收失約費失敗',
      reassign: '重新指派預約失敗',
      forceRelease: '釋放凍結失敗',
      update: '更新預約失敗',
    },
  },
};
